/**
 * A hajtás alatti főoldali CSS aktiválása.
 *
 * A teljes stíluslap már `preload` állapotban a gyorsítótárba kerül, ezért
 * az első görgetésnél csak a `rel` változik: nincs hálózati várakozás és
 * nincs villanás. Közvetlen aloldali megnyitásnál azonnal aktiváljuk, mert
 * ott nem a főoldali hero a kritikus nézet.
 */
function deferredStyle(): HTMLLinkElement | null {
  return document.querySelector<HTMLLinkElement>('link[data-deferred-style]')
}

const EVENTS = ['wheel', 'touchstart', 'pointerdown', 'keydown', 'scroll'] as const

export function teljesStilusAktivalasa(): void {
  const link = deferredStyle()
  if (!link || link.rel === 'stylesheet') return

  link.rel = 'stylesheet'
  link.removeAttribute('as')
  link.removeAttribute('data-deferred-style')

  for (const event of EVENTS) window.removeEventListener(event, teljesStilusAktivalasa)
}

export function halasztottStilusBekotese(): void {
  if (!deferredStyle()) return

  if (location.pathname !== '/') {
    teljesStilusAktivalasa()
    return
  }

  for (const event of EVENTS) {
    window.addEventListener(event, teljesStilusAktivalasa, { passive: true, once: true })
  }

  /* Visszaállított görgetési pozíció vagy közvetlen `/#szakasz` megnyitás. */
  requestAnimationFrame(() => {
    if (scrollY > 0 || location.hash) teljesStilusAktivalasa()
  })
}
